import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

const experienceCenterService = {
  index: async (
    pageNumber: number | undefined = 1,
    status: string | undefined,
    sortOrder: string | undefined,
  ) => {
    if (!status || status === 'ALL') {
      return await axios.get(`/experience-centre?pageNumber=${pageNumber}&sortOrder=${sortOrder}`)
    }
    return await axios.get(
      `/experience-centre?pageNumber=${pageNumber}&sortOrder=${sortOrder}&status=${status}`,
    )
  },
  exportExperienceCenter: async (sortOrder: string, status: string | undefined) => {
    if (status && status !== 'ALL') {
      return await axios.get(
        `/experience-centre/export/csv?sortOrder=${sortOrder}&status=${status}`,
      )
    } else {
      return axios.get(`/experience-centre/export/csv?sortOrder=${sortOrder}`)
    }
  },

  async searchExperienceCenters(
    endpoint: string,
    pageNumber: number,
    sortOrder: string,
    status: string | undefined,
  ) {
    const statusParam =
      status === undefined || status === 'ALL' ? '' : `&status=${encodeURIComponent(status)}`
    const queryParams = `${endpoint}&pageNumber=${pageNumber ?? 1}&sortOrder=${encodeURIComponent(sortOrder)}${statusParam}`
    return await axios.get(`/experience-centre?${queryParams}`)
  },

  search: async (endpoint: string, pageNumber: number, sortOrder: string, status: string) => {
    const queryParams = `${endpoint}&pageNumber=${pageNumber ?? 1}&sortOrder=${sortOrder}&status=${status}`
    return await axios.get(`/experience-centre?${queryParams}`)
  },

  single: async (id: string | undefined) => {
    return await axios.get(`/experience-centre/${id}`)
  },

  reject: async (data: { rejectionReason: string }, id: string) => {
    return await axios.put(`/experience-centre/${id}/reject`, data)
  },
  approve: async (data: { approvalNotes: string }, id: string) => {
    return await axios.put(`/experience-centre/${id}/approve`, data)
  },
  activate: async (
    id: string,
    data: {
      installationCompletedAt: string
      nextSubscriptionPaymentDueDate?: string
    },
  ) => {
    return await axios.put(`/experience-centre/${id}/installation-complete`, data)
  },

  decommision: async (id: string | undefined) => {
    return await axios.put(`/experience-centre/${id}/decommission`)
  },
}

export default experienceCenterService
